var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.515 2.99235H10.8667V2.52568H14.8V6.45902H14.3333V3.8274V3.3475L13.9925 3.68537L9.54761 8.09193L9.42897 8.20955L9.52358 8.34724C9.80078 8.75063 10.0281 9.17628 10.2058 9.62438C10.3798 10.0631 10.4667 10.5186 10.4667 10.9924C10.4667 12.1484 10.067 13.1215 9.26509 13.9237C8.46319 14.7259 7.49047 15.1257 6.33485 15.1257C5.1792 15.1257 4.20592 14.726 3.40299 13.924C2.60011 13.1221 2.2 12.1494 2.2 10.9939C2.2 9.83824 2.5998 8.86497 3.40205 8.06203C4.20424 7.25914 5.17731 6.85902 6.33333 6.85902C6.80731 6.85902 7.25994 6.94521 7.69263 7.11741L7.6927 7.11744C8.13464 7.29312 8.55545 7.52087 8.95527 7.80105L9.09276 7.8974L9.21147 7.77869L13.6564 3.33377L13.9978 2.99235H13.515ZM3.73841 8.40039L3.7384 8.40041C3.02538 9.11541 2.66667 9.98399 2.66667 10.995C2.66667 12.0062 3.02639 12.8741 3.74138 13.5873L3.74139 13.5873C4.45639 14.3003 5.32497 14.659 6.33593 14.659C7.34721 14.659 8.21509 14.2993 8.92825 13.5843L8.92827 13.5843C9.64128 12.8693 10 12.0007 10 10.9897C10 9.97848 9.64028 9.11059 8.92529 8.39743L8.92527 8.39742C8.21028 7.6844 7.34169 7.32568 6.33073 7.32568C5.31946 7.32568 4.45157 7.6854 3.73841 8.40039Z",
    fill: "#189FAA",
    stroke: "#189FAA",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMale);
export default __webpack_public_path__ + "static/media/male.f8d9903005c6b4e6511f288129d50691.svg";
export { ForwardRef as ReactComponent };